export default "__VITE_ASSET__BN_tHJE0__"